module.exports = __webpack_public_path__ + "static/media/done.127407e7.svg";